import BaseModel from "../default/base-model";
import {Group} from "./group";

export class User extends BaseModel {
    name: string;
    username: string;
    password: string;
    email: string;
    is_active: boolean;
    perfil?: string;

    // antigo
    group: Group[] | undefined;
    is_superuser: boolean;
    userStatus: string;
    associated: boolean;

    confirmPassword: string;


    constructor() {
        super();
        this.username = "";
        this.password = "";
        this.email = "";
        this.name = "";
        this.is_active = true;
        this.perfil = "";

        // antigo
        this.userStatus = "ACTIVE";
        this.is_superuser = false;
        this.group = [];
        this.associated = false;
        this.confirmPassword = "";

    }
}

export class Permission {
    profile!: Profile[];
}

export enum Profile {
    ADMIN = 'Administrador',
    OPERACIONAL = 'Operacional',
    SUPORTE = 'Suporte',
}
